import React from 'react';
import autobind from 'autobind';
import { observer, inject } from 'mobx-react';
import hash from 'object-hash';

import { Scroller } from '@components/Scroller';

import { BlockItem, BlockItemProps } from './BlockItem';
import { EntryPage as EntryPageStore } from '@patient/ui/shared/store';
import { assertIsDefined } from '@utils/assertIsDefined';

interface Props extends BlockItemProps {
    blockIndex: number;
}

interface StoreProps {
    entryPage: EntryPageStore;
}

@observer
class Component extends React.Component<Props & StoreProps> {
    public render(): React.ReactNode {
        const {
            entryPage: { rightContentMenu },
            blockIndex,
        } = this.props;

        const block = rightContentMenu.getItem(blockIndex);
        assertIsDefined(block, `Right content menu has block ${blockIndex}`);

        return React.createElement(BlockItem, {
            title: block.title,
            isSelected: rightContentMenu.selectedItemIndex === blockIndex,
            onClick: this.handleItemClick,
        });
    }

    @autobind
    protected handleItemClick() {
        const {
            entryPage: { rightContentMenu },
            blockIndex,
        } = this.props;

        const block = rightContentMenu.getItem(blockIndex);
        assertIsDefined(block, `Right content menu has block ${blockIndex}`);

        Scroller.scrollTo({
            id: hash(block.title),
        });

        rightContentMenu.selectedItemIndex = blockIndex;
    }
}

export const BlockItemContainer = inject<Props, StoreProps>(EntryPageStore.Name)(Component);
